import style from "./Tooltip.module.scss";
import CloseIcon from "../../assets/images/close-dark.svg";
import { useState } from "react";

const Tooltip = ({
  placeholderContent,
  infoText,
  className,
}: {
  placeholderContent: any;
  infoText: string;
  className?: string;
}) => {
  const [viewToggle, setViewToggle] = useState(false);
  return (
    <div className={`${style.tooltip} ${className}`}>
      <div
        className={style.tooltip__holder}
        onClick={() => setViewToggle(!viewToggle)}
      >
        {placeholderContent}
      </div>

      {viewToggle && infoText && (
        <div className={style.tooltip__text}>
          {infoText}
          <img onClick={() => setViewToggle(false)} src={CloseIcon} alt="" />
        </div>
      )}
    </div>
  );
};
export default Tooltip;
